module.exports = __webpack_public_path__ + "img/trash-dove.d4626c5f.png";